
<div class="spinner-loader-container" *ngIf="loaderSpinnerService.displayCustomSpinner">
  <mat-progress-spinner
    attr.aria-label="{{ 'application_features.loading' | translate }}"
    class="carm-loader-spinner mat-spinner-color"
    mode="indeterminate"
    value="50">
  </mat-progress-spinner>
  <div class='message'>
    <h3 [innerHtml]="'common.timeout_message'| translate"></h3>
  </div>
</div>
